import { findTransitionController } from 'util/core-transition-component';
import { revealRectangle } from 'util/animation/reveal/reveal';
import type { RefObject } from 'react';
import type { HeadingRef } from 'components/atoms/heading/Heading.data';
import type { TextRef } from 'components/atoms/text/Text.data';

interface StickyNoteRefs {
  elementRef?: RefObject<HTMLElement>;
  titleRef: RefObject<HeadingRef | null>;
  textRef: RefObject<TextRef | null>;
  index?: number;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, titleRef, textRef, index }: StickyNoteRefs,
): void {
  const title = findTransitionController(titleRef);
  const text = findTransitionController(textRef);

  if (elementRef?.current) {
    timeline.add(
      revealRectangle(elementRef.current, {
        from: 'bottom',
        duration: 0.5,
        // delay: 0.1 * index!,
      }),
    );
  }

  if (title) {
    timeline.add(title.getTimeline('in') as gsap.core.Timeline);
  }

  if (text) {
    timeline.add(text.getTimeline('in') as gsap.core.Timeline, '<0.2');
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, textRef }: StickyNoteRefs,
): void {
  const title = findTransitionController(titleRef);
  const text = findTransitionController(textRef);

  if (title) {
    timeline.add(title.getTimeline('out') as gsap.core.Timeline);
  }

  if (text) {
    timeline.add(text.getTimeline('out') as gsap.core.Timeline);
  }
}
